import React, { useEffect, useState } from 'react';
// import * as styles from './index.module.less';
import StopServingBanner from '../stop-serving';
import DiscountBanner from '../discount-banner';
import SwitchLanguageBanner from '../switch-language-banner';
import FeatureBanner from '../feature-banner';

export enum TopBannerType {
  stop,
  discount,
  switchLanguage,
  feature,
}

interface IProps {
  type: TopBannerType;
  lsKey?: string;
  lang?: 'en' | 'ja';
}

/**
 * TODO: key需要根据每次发布banner时间更改，以免之前用户关闭过看不到公告🪧
 */
const LS_TOP_BANNER_KEY = 'stop-serving-banner-close-count-11-21';

const TopBanner = ({ type, lang = 'ja', lsKey = LS_TOP_BANNER_KEY }: IProps) => {
  const [isClose, setIsClose] = useState(true);

  const handleCloseBtnClick = (e: MouseEvent) => {
    e.stopPropagation();
    const closedCount = localStorage.getItem(lsKey);
    if (closedCount && !isNaN(Number(closedCount))) {
      const storageCount = Number(closedCount) + 1;
      localStorage.setItem(lsKey, JSON.stringify(storageCount));
    } else {
      localStorage.setItem(lsKey, '1');
    }
    setIsClose(true);
  };

  const RenderCom = () => {
    switch (type) {
      case TopBannerType.stop:
        return <StopServingBanner type={lang} onClose={handleCloseBtnClick} />;
      case TopBannerType.discount:
        return <DiscountBanner type={lang} onClose={handleCloseBtnClick} />;
      case TopBannerType.switchLanguage:
        return <SwitchLanguageBanner onClose={handleCloseBtnClick} />;
      case TopBannerType.feature:
        return <FeatureBanner lng={lang} onClose={handleCloseBtnClick} />;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    const closedCount = localStorage.getItem(lsKey);

    if (Number(closedCount) < 2) {
      setIsClose(false);
    }

    if (Number(closedCount) >= 2) {
      setIsClose(true);
    }
  }, [lsKey]);
  return isClose ? <></> : <RenderCom />;
};
export default TopBanner;
